import { extendTheme } from "@chakra-ui/react";
import { buttonTheme } from "./components/buttonTheme";
import textTheme from "./components/textTheme";
import breakpoints from "./foundations/breakpoints";
import { colors } from "./foundations/colors";
import fonts from "./foundations/fonts";
import fontWeights from "./foundations/fontWeights";
import styles from "./styles";
import fontSizes from "./foundations/fontSizes";
import radii from "./foundations/radii";

const theme = extendTheme({
  styles,
  fonts,
  breakpoints,
  fontWeights,
  fontSizes,
  colors,
  radii,
  components: {
    Text: textTheme,
    Button: buttonTheme,
  },
});

export default theme;
